import { render, staticRenderFns } from "./Screening.vue?vue&type=template&id=f0f48506&scoped=true"
import script from "./Screening.vue?vue&type=script&lang=js"
export * from "./Screening.vue?vue&type=script&lang=js"
import style0 from "./Screening.vue?vue&type=style&index=0&id=f0f48506&prod&lang=scss"
import style1 from "./Screening.vue?vue&type=style&index=1&id=f0f48506&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f48506",
  null
  
)

export default component.exports